import advocacyAndHumanRights from '../assets/categories/advocacy.png'
import animals from '../assets/categories/animal.png'
import artsAndCulture from '../assets/categories/artsCulture.png'
import boardDevelopment from '../assets/categories/broadDevelopment.png'
import childrenAndYouth from '../assets/categories/children.png'
import community from '../assets/categories/community.png'
import computersAndTechnology from '../assets/categories/computerTech.png'
import crisisSupport from '../assets/categories/crisisSupport.png'
import disabled from '../assets/categories/peopleWithDisabilities.png'
import disasterRelief from '../assets/categories/disasterRelief.png'
import educationAndLiteracy from '../assets/categories/education.png'
import emergencyAndSafety from '../assets/categories/emergency.png'
import employment from '../assets/categories/employment.png'
import environment from '../assets/categories/environment.png'
import gayLesbianBiTrans from '../assets/categories/lgbtq.png'
import healthAndMedicine from '../assets/categories/healthAndMedicine.png'
import homelessAndHousing from '../assets/categories/homelessness.png'
import hunger from '../assets/categories/hunger.png'
import immigrantsAndRefugees from '../assets/categories/immigration.png'
import international from '../assets/categories/international.png'
import justiceAndLegal from '../assets/categories/justiceLegal.png'
import mediaAndBroadcasting from '../assets/categories/media.png'
import men from '../assets/categories/men.png'
import mentoring from '../assets/categories/mentoring.png'
import mentalHealth from '../assets/categories/mentalHealth.png'
import music from '../assets/categories/music.png'
import politics from '../assets/categories/politics.png'
import raceAndEthnicity from '../assets/categories/raceEthnicity.png'
import religion from '../assets/categories/faith.png'
import seniors from '../assets/categories/seniors.png'
import sportsAndRecreation from '../assets/categories/sports.png'
import veteransAndMilitaryFamilies from '../assets/categories/veteransMilitary.png'
import voting from '../assets/categories/voting.png'
import women from '../assets/categories/women.png'

export const CATEGORIES = {
  advocacyAndHumanRights,
  animals,
  artsAndCulture,
  boardDevelopment,
  childrenAndYouth,
  community,
  computersAndTechnology,
  crisisSupport,
  disabled,
  disasterRelief,
  educationAndLiteracy,
  emergencyAndSafety,
  employment,
  environment,
  gayLesbianBiTrans,
  healthAndMedicine,
  homelessAndHousing,
  hunger,
  immigrantsAndRefugees,
  international,
  justiceAndLegal,
  mediaAndBroadcasting,
  men,
  mentoring,
  mentalHealth,
  music,
  politics,
  raceAndEthnicity,
  religion,
  seniors,
  sportsAndRecreation,
  veteransAndMilitaryFamilies,
  voting,
  women,
}
